(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
